import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import Footer from "./Footer";

const ProblemsSubmitting = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const accordianItems = [
    {
      title: <p className="font-bold">Project is not shared</p>,
      description: (
        <p>
            On the Scratch online editor, please make sure that the "share" option on the upper-right is tapped. For more info, <a className="border-b border-gray-400 hover:border-gray-700 transition-all duration-700" href="https://en.scratch-wiki.info/wiki/Project_Sharing">tap here</a>.
        </p>
      ),
    },
    {
      title: (
        <p className="font-bold">Your project has already been submitted</p>
      ),
      description: (
        <p>
            Either someone submitted your project, or you submitted someone's project! Look on the showcase on the Scratchathon page to figure out what happened...
        </p>
      ),
    },
    {
      title: <p className="font-bold">You didn't enter the right number</p>,
      description: (
        <p>
            Well... Check that the right number is entered.
        </p>
      ),
    },
    {
      title: <p className="font-bold">Our servers are down (Contact Us)</p>,
      description: (
        <p>
            That's a problem! Please reach out to the moderators or the heads of the Scratchathon on our Discord as soon as possible for us to resolve the issue.
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-end">
        <button
          onClick={onOpen}
          className="text-xs font-medium text-gray-400 cursor-pointer hover:underline"
        >
          I'm having problems submitting...
        </button>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Why isn't my project being submitted?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Accordion allowToggle allowMultiple defaultIndex={[0]}>
              {accordianItems.map((accordian, i) => {
                return (
                  <div key={i} className="">
                    <AccordionItem defaultChecked={true}>
                      <AccordionButton>
                        <Box flex="1" textAlign="left">
                          {accordian.title}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        {accordian.description}
                      </AccordionPanel>
                    </AccordionItem>
                  </div>
                );
              })}
            </Accordion>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ProblemsSubmitting;
